import shared from './shared';
import { ID_SCAN_FIELDS } from '../factories/id-scan-field';

/**
 * @param {Object}            server       Mirage Server
 * @param {Object}            options      Options to create extra models, see deconstructed object below for keys
 */
export default function (server, options = {}) {
  let deliveriesSubscription;
  let printer;
  let badges;
  let agreementPages;
  let photoPages;
  let summaryPages;
  let idScanPages;
  let visitorsLocationSubscription;
  let visitorsRoomsSubscription;
  let blacklistFilter;

  const {
    withPlans = false,
    withSubscriptionPlans = false,
    withDeliveriesSubscription = false,
    withPrinter = false,
    withBadges = false,
    withAgreementPages = false,
    withPhotoPages = false,
    withSummaryPages = false,
    withIdScanPages = false,
    withVisitorsLocationSubscription = false,
    withRoomsLocationSubscription = false,
    withBlacklistFilter = false,
    withIdScanFields = false,
  } = options;

  const {
    company,
    locations: [SFLocation, NYLocation],
  } = shared(server);

  const signInFieldPages = [
    server.create('sign-in-field-page', 'withFullNameSignInField', 'withEmailAddressSignInField'),
    ...server.createList('sign-in-field-page', 2),
  ];

  const vrSubscription = server.create('subscription', 'asStandard', {
    company,
    app: 'visitors',
    nonRenewing: false,
    onExpiredTrial: false,
  });
  company.update({ subscription: vrSubscription });

  const interviewFlow = server.create('flow', {
    enabled: true,
    name: 'Interview',
    location: SFLocation,
    signInFieldPage: signInFieldPages[0],
  });

  const deliveryFlow = server.create('flow', {
    enabled: true,
    name: 'Delivery',
    location: SFLocation,
    signInFieldPage: signInFieldPages[1],
  });

  const nyInterviewFlow = server.create('flow', {
    enabled: true,
    name: 'NY Interview',
    location: NYLocation,
    signInFieldPage: signInFieldPages[2],
  });

  if (withPrinter) {
    printer = server.create('printer', { ip: '192.168.1.1', location: SFLocation });
  }

  if (withPlans) {
    server.createList('plan', 8);
  }

  if (withSubscriptionPlans) {
    server.createList('subscription-plan', 33).forEach((subscriptionPlan) => {
      subscriptionPlan.update({
        alternateId: subscriptionPlan.tempAlternateId,
      });
    });
  }

  if (withDeliveriesSubscription) {
    deliveriesSubscription = server.create('subscription', 'asDeliveriesOnTrial', {
      companyId: company.id,
      plan: 'standard',
      isManual: false,
    });

    server.db.companies.update(company.id, {
      subscriptionId: vrSubscription.id,
      deliveriesSubscriptionId: deliveriesSubscription.id,
    });
  }

  if (withBadges) {
    badges = server.createList('badge', 3, 'withFlowAssign');
  }

  if (withAgreementPages) {
    agreementPages = server.createList('agreement-page', 3, 'withFlowAssign');
  }

  if (withPhotoPages) {
    photoPages = server.createList('photo-page', 3, 'withFlowAssign');
  }

  if (withSummaryPages) {
    summaryPages = server.createList('summary-page', 3, 'withFlowAssign');
  }

  if (withIdScanPages) {
    idScanPages = server.createList('id-scan-page', 3, 'withFlowAssign');
  }

  if (withVisitorsLocationSubscription) {
    const billingCompany = server.schema.billingCompanies.first();
    visitorsLocationSubscription = server.create('location-subscription', 'traitVisitorsOnTrial', {
      location: SFLocation,
      company,
      billingCompany,
    });
  }

  if (withRoomsLocationSubscription) {
    const billingCompany = server.schema.billingCompanies.first();
    visitorsRoomsSubscription = server.create('location-subscription', 'traitRoomsTrial', {
      location: SFLocation,
      company,
      billingCompany,
    });
  }

  if (withBlacklistFilter) {
    blacklistFilter = server.schema.create('blacklistFilter', {
      createdBy: 'The Woodland Elves on the Dawn of the Third Age',
      keyword: 'My precious',
      reason: 'To keep the ring secret and safe',
      locationId: SFLocation.id,
    });
  }

  if (withIdScanFields) {
    server.createList('id-scan-field', ID_SCAN_FIELDS.length);
  }

  return {
    company,
    subscription: vrSubscription,
    deliveriesSubscription,
    locations: [SFLocation, NYLocation],
    signInFieldPages,
    flows: [interviewFlow, deliveryFlow, nyInterviewFlow],
    printer,
    badges,
    agreementPages,
    photoPages,
    summaryPages,
    idScanPages,
    visitorsLocationSubscription,
    visitorsRoomsSubscription,
    blacklistFilter,
  };
}
